/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2023-10-17 19:20:53
 */
import Excel from 'exceljs'
import FileSaver from 'file-saver'
import type { ExcelParams, GeoItem } from './types'

export const exportExcel = (params: ExcelParams, data: Partial<GeoItem>[]) => {
  // bug： 设置colmuns 字段属性和内容 的时候，当前只能在第一行，
  // 如果需要表头，需要对相关单元格内容进行内容的覆盖
  const fontRequired = { size: 16, bold: true, color: { argb: 'FFFF0202' } }
  const font = { size: 16, bold: true }

  const fill: Excel.FillPattern = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFFCE4D6' }
  }

  // 创建对象和表
  const workbook = new Excel.Workbook()
  const sheet = workbook.addWorksheet('My Sheet')

  const colmunsArray: Partial<Excel.Column>[] = []
  const base = 'A'.charCodeAt(0)
  params.colmuns.forEach((item, index) => {
    // 设置列属性 字体样式
    colmunsArray.push({
      header: item.name,
      key: item.value,
      width: item.width,
      style: { font: { size: item.size } }
    })
    // 设置内容 填充背景 字体样式
    const num = String.fromCharCode(base + index)
    sheet.getCell(`${num}2`).value = item.name
    sheet.getCell(`${num}2`).fill = fill
    sheet.getCell(`${num}2`).font = item.required ? fontRequired : font
  })
  sheet.columns = colmunsArray

  sheet.getRow(1).height = 50
  sheet.mergeCells('A1', 'F1')
  // 自动换行
  sheet.getCell('A1').alignment = { wrapText: true }
  sheet.getCell('A1').value = {
    // 第二行加入空格符号，换行文本
    richText: [
      {
        font: { size: 18, color: { argb: 'FF305496' }, bold: true },
        text: params.title
      },
      {
        font: { size: 18, color: { argb: 'FF305496' }, bold: true },
        text: '\r'
      },
      ...params.subTitle.map(({ text, fontColor }) => ({
        font: {
          size: 12,
          color: { argb: fontColor || 'FF305496' },
          bold: true
        },
        text
      }))
    ]
  }

  sheet.addRows(data) // 添加数据

  workbook.xlsx.writeBuffer().then((result) => {
    const blob = new Blob([result], {
      type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
    FileSaver.saveAs(blob, params.exportFileName)
  })
}

export const generateExcelParams: ExcelParams = {
  title: '定位失败选项列表：',
  subTitle: [
    {
      text: '失败原因：地址信息不完善，'
    },
    {
      text: '无法定位到该地点',
      fontColor: 'FFFF0202'
    },
    {
      text: '。重新编辑后上传，或将该文件导入后，在线调整定位。'
    }
  ],
  colmuns: [
    {
      name: '选项名称', // 表头
      value: 'content', // 字段
      required: true, // 是否必选（标红）
      width: 40, // 列表宽度
      size: 14 // 字体尺寸
    },
    {
      name: '详细地址',
      value: 'address',
      required: false,
      width: 40,
      size: 14
    },
    {
      name: '经度（gcj02格式）',
      value: 'lng',
      required: false,
      width: 40,
      size: 14
    },
    {
      name: '纬度（gcj02格式）',
      value: 'lat',
      required: false,
      width: 40,
      size: 14
    }
  ],
  exportFileName: '今日水印相机-定位失败选项.xlsx' // 导出文件名称
}
